import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { ComponentPropsWithoutRef } from "react";

type TableHeadWithFontBoldProps = ComponentPropsWithoutRef<typeof TableHead>;

export const TableHeadWithFontBold = ({
  className,
  ...props
}: TableHeadWithFontBoldProps) => (
  <TableHead
    className={cn("font-bold text-monotone-9", className)}
    {...props}
  />
);
